import { render, staticRenderFns } from "./CheckParIcon.vue?vue&type=template&id=5950cdf5&scoped=true&"
import script from "./CheckParIcon.vue?vue&type=script&lang=js&"
export * from "./CheckParIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5950cdf5",
  null
  
)

export default component.exports